import React from 'react';
import { Button } from '@chakra-ui/react'; // Supondo que você esteja usando Chakra UI

const CustomButton = ({ 
    text, 
    bgColor, 
    textColor, 
    isDisabled, 
    onClick, 
    hoverBgColor, 
    activeBgColor,
    ...rest
}: any) => {
    return (
        <Button
            w='full'
            bg={bgColor}
            py={6}
            color={textColor}
            borderRadius='full'
            border='none !important'
            fontWeight='bold'
            autoFocus={false}
            _loading={{bg: '#222 !important'}}
            _focusVisible={{border: 'none', shadow: 'none'}}
            _disabled={{ bg: '#E8E8E8', color: "#222", _hover: { bg: '#E8E8E8' } }}
            _hover={{ background: hoverBgColor }}
            _active={{ transform: "scale(0.95)", background: activeBgColor }}
            onClick={onClick}
            
            {...rest}
        >
            {text}
        </Button>
    );
};

export default CustomButton;